import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { useToast } from 'context/providers/ToastProvider';
import PropTypes from 'prop-types';
import useCopyToClipboard from "hooks/useCopyToClipboard";

const CopyLabel = ({ code, placement, padding }) => {
    const { showSuccessToast } = useToast();
    const [isCopied, handleCopy] = useCopyToClipboard(2000);

    return (
        <OverlayTrigger
            placement={placement}
            overlay={
                <Tooltip id="tooltip-copy">
                    <span>Copiar</span>
                </Tooltip>
            }
        >
            <span
                onClick={() => {
                    handleCopy(code);
                    showSuccessToast('Copiado en el portapapeles: ' + code);
                }}
                style={{
                    cursor: 'pointer',
                    display: 'inline-flex',
                    alignItems: 'center',
                    padding: padding,
                    borderRadius: '4px',
                    color: isCopied ? '#748194' : '#007bff',
                    userSelect: 'none'
                }}
            >
                <>{isCopied ? "¡Copiado!" : code}</>
            </span>
        </OverlayTrigger>
    );
};

CopyLabel.propTypes = {
    code: PropTypes.string,
    placement: PropTypes.string,
    padding: PropTypes.string
};

export default CopyLabel;
